import {
  BApp,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownItemButton,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BImg,
  BInputGroup,
  BInputGroupText,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BNav,
  BNavItem,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavbarToggle,
  BOffcanvas,
  BPagination,
  BRow,
  BSpinner,
  BTab,
  BTable,
  BTabs,
  BTbody,
  BTd,
  BTh,
  BThead,
  BToast,
  BTooltip,
  BTr,
} from 'bootstrap-vue-next';
import { h } from 'vue';

export default function registerBootstrapCompat(app) {
  app.component('b-app', BApp);
  app.component('b-container', BContainer);
  app.component('b-sidebar', BOffcanvas);
  app.component('b-row', BRow);
  app.component('b-col', BCol);
  app.component('b-form', BForm);
  app.component('b-form-group', BFormGroup);
  app.component('b-form-input', BFormInput);
  app.component('b-form-select', BFormSelect);
  app.component('b-form-select-option', BFormSelectOption);
  app.component('b-form-checkbox-group', BFormCheckboxGroup);
  app.component('b-form-checkbox', BFormCheckbox);
  app.component('b-form-textarea', BFormTextarea);
  app.component('b-form-invalid-feedback', BFormInvalidFeedback);
  app.component('b-button', BButton);
  app.component('b-link', BLink);
  app.component('b-nav', BNav);
  app.component('b-nav-item', BNavItem);
  app.component('b-navbar', BNavbar);
  app.component('b-navbar-brand', BNavbarBrand);
  app.component('b-navbar-toggle', BNavbarToggle);
  app.component('b-navbar-nav', BNavbarNav);
  app.component('b-collapse', BCollapse);
  app.component('b-dropdown', BDropdown);
  app.component('b-dropdown-item', BDropdownItem);
  app.component('b-dropdown-item-button', BDropdownItemButton);
  app.component('b-dropdown-divider', BDropdownDivider);
  app.component('b-tab', BTab);
  app.component('b-tabs', BTabs);
  app.component('b-card', BCard);
  app.component('b-card-text', BCardText);
  app.component('b-badge', BBadge);
  app.component('b-img', BImg);
  app.component('b-list-group', BListGroup);
  app.component('b-list-group-item', BListGroupItem);
  app.component('b-tooltip', BTooltip);
  app.component('b-modal', BModal);
  app.component('b-toast', BToast);
  app.component('b-spinner', BSpinner);
  app.component('b-table', BTable);
  app.component('b-td', BTd);
  app.component('b-th', BTh);
  app.component('b-tr', BTr);
  app.component('b-thead', BThead);
  app.component('b-tbody', BTbody);
  app.component('b-pagination', BPagination);
  app.component('b-input-group', BInputGroup);
  app.component('b-input-group-text', BInputGroupText);
  app.component('b-input-group-prepend', {
    render() {
      return h('span', { class: 'input-group-text' }, this.$slots.default?.());
    },
  });
  app.component('b-input-group-append', {
    render() {
      return h('span', { class: 'input-group-text' }, this.$slots.default?.());
    },
  });
}
